import {auth} from './auth'
import {admin} from './admin'
import {info} from './info'

export const user = {
    namespaced: true,
    modules: {
        auth: auth,
        admin: admin,
        info: info
    }
}